import { orvalRequest } from '../orval-request.js';
;
export const getGetPortalOnboardingUrl = () => {
    return `/api/portal/onboarding`;
};
export const getPortalOnboarding = async (options) => {
    return orvalRequest(getGetPortalOnboardingUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getSavePortalOnboardingUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/portal/onboarding?${stringifiedParams}` : `/api/portal/onboarding`;
};
export const savePortalOnboarding = async (onboardingRequestDto, params, options) => {
    return orvalRequest(getSavePortalOnboardingUrl(params), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(onboardingRequestDto)
    });
};
;
export const getGetPortalKycUrl = () => {
    return `/api/portal/kyc`;
};
export const getPortalKyc = async (options) => {
    return orvalRequest(getGetPortalKycUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getSavePortalKycUrl = () => {
    return `/api/portal/kyc`;
};
export const savePortalKyc = async (kycDto, options) => {
    return orvalRequest(getSavePortalKycUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(kycDto)
    });
};
;
export const getUpdatePortalCustomerUrl = () => {
    return `/api/portal/customers`;
};
export const updatePortalCustomer = async (customerRequestDto, options) => {
    return orvalRequest(getUpdatePortalCustomerUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(customerRequestDto)
    });
};
;
export const getGetEmailTemplateUrl = (id) => {
    return `/api/backoffice/email-templates/${id}`;
};
export const getEmailTemplate = async (id, options) => {
    return orvalRequest(getGetEmailTemplateUrl(id), {
        ...options,
        method: 'GET'
    });
};
;
export const getUpdateEmailTemplateUrl = (id) => {
    return `/api/backoffice/email-templates/${id}`;
};
export const updateEmailTemplate = async (id, emailTemplateRequestDto, options) => {
    return orvalRequest(getUpdateEmailTemplateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(emailTemplateRequestDto)
    });
};
;
export const getDeleteEmailTemplateUrl = (id) => {
    return `/api/backoffice/email-templates/${id}`;
};
export const deleteEmailTemplate = async (id, options) => {
    return orvalRequest(getDeleteEmailTemplateUrl(id), {
        ...options,
        method: 'DELETE'
    });
};
;
export const getListBackofficeCustomersUrl = () => {
    return `/api/backoffice/customers`;
};
export const listBackofficeCustomers = async (options) => {
    return orvalRequest(getListBackofficeCustomersUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getUpdateBackofficeCustomerUrl = () => {
    return `/api/backoffice/customers`;
};
export const updateBackofficeCustomer = async (customerRequestDto, options) => {
    return orvalRequest(getUpdateBackofficeCustomerUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(customerRequestDto)
    });
};
;
export const getUpdateBackofficeCustomerOnboardingUrl = (id) => {
    return `/api/backoffice/customers/${id}/onboarding`;
};
export const updateBackofficeCustomerOnboarding = async (id, onboardingRequestDto, options) => {
    return orvalRequest(getUpdateBackofficeCustomerOnboardingUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(onboardingRequestDto)
    });
};
;
export const getGetAccessGrantUrl = (id) => {
    return `/api/backoffice/access-grants/${id}`;
};
export const getAccessGrant = async (id, options) => {
    return orvalRequest(getGetAccessGrantUrl(id), {
        ...options,
        method: 'GET'
    });
};
;
export const getUpdateAccessGrantUrl = (id) => {
    return `/api/backoffice/access-grants/${id}`;
};
export const updateAccessGrant = async (id, accessGrantRequestDto, options) => {
    return orvalRequest(getUpdateAccessGrantUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(accessGrantRequestDto)
    });
};
;
export const getDeleteAccessGrantUrl = (id) => {
    return `/api/backoffice/access-grants/${id}`;
};
export const deleteAccessGrant = async (id, options) => {
    return orvalRequest(getDeleteAccessGrantUrl(id), {
        ...options,
        method: 'DELETE'
    });
};
;
export const getResumeCheckoutSessionUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/portal/payment/session?${stringifiedParams}` : `/api/portal/payment/session`;
};
export const resumeCheckoutSession = async (params, options) => {
    return orvalRequest(getResumeCheckoutSessionUrl(params), {
        ...options,
        method: 'GET'
    });
};
;
export const getCreateCheckoutSessionUrl = () => {
    return `/api/portal/payment/session`;
};
export const createCheckoutSession = async (createCheckoutSessionRequestDto, options) => {
    return orvalRequest(getCreateCheckoutSessionUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createCheckoutSessionRequestDto)
    });
};
;
export const getFinishCheckoutSessionUrl = () => {
    return `/api/portal/payment/session/finish`;
};
export const finishCheckoutSession = async (finishCheckoutSessionRequestDto, options) => {
    return orvalRequest(getFinishCheckoutSessionUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(finishCheckoutSessionRequestDto)
    });
};
;
export const getConfirmPaymentUrl = () => {
    return `/api/portal/payment/confirm`;
};
export const confirmPayment = async (confirmPaymentRequestDto, options) => {
    return orvalRequest(getConfirmPaymentUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(confirmPaymentRequestDto)
    });
};
;
export const getHandlePaymentWebhookUrl = (provider) => {
    return `/api/portal/payment/checkout/webhook/${provider}`;
};
export const handlePaymentWebhook = async (provider, handlePaymentWebhookBody, options) => {
    return orvalRequest(getHandlePaymentWebhookUrl(provider), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(handlePaymentWebhookBody)
    });
};
;
export const getGetPortalAuthenticatedUserUrl = () => {
    return `/api/portal/me`;
};
export const getPortalAuthenticatedUser = async (options) => {
    return orvalRequest(getGetPortalAuthenticatedUserUrl(), {
        ...options,
        method: 'POST'
    });
};
;
export const getStartPortalKycUrl = () => {
    return `/api/portal/kyc/start`;
};
export const startPortalKyc = async (kycStartRequestDto, options) => {
    return orvalRequest(getStartPortalKycUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(kycStartRequestDto)
    });
};
;
export const getUploadPortalKycPoaUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/portal/kyc/poa?${stringifiedParams}` : `/api/portal/kyc/poa`;
};
export const uploadPortalKycPoa = async (params, uploadPortalKycPoaBody, options) => {
    const formData = new FormData();
    if (uploadPortalKycPoaBody?.file !== undefined) {
        formData.append(`file`, uploadPortalKycPoaBody.file);
    }
    return orvalRequest(getUploadPortalKycPoaUrl(params), {
        ...options,
        method: 'POST',
        body: formData,
    });
};
;
export const getHandleKycCallbackUrl = (provider) => {
    return `/api/portal/kyc/callback/${provider}`;
};
export const handleKycCallback = async (provider, options) => {
    return orvalRequest(getHandleKycCallbackUrl(provider), {
        ...options,
        method: 'POST'
    });
};
;
export const getGetCurrentPortalCustomerUrl = () => {
    return `/api/portal/customers/me`;
};
export const getCurrentPortalCustomer = async (options) => {
    return orvalRequest(getGetCurrentPortalCustomerUrl(), {
        ...options,
        method: 'POST'
    });
};
;
export const getDebugSendEmailUrl = () => {
    return `/api/backoffice/email/debug`;
};
export const debugSendEmail = async (debugSendEmailRequestDto, options) => {
    return orvalRequest(getDebugSendEmailUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(debugSendEmailRequestDto)
    });
};
;
export const getListEmailTemplatesUrl = () => {
    return `/api/backoffice/email-templates`;
};
export const listEmailTemplates = async (options) => {
    return orvalRequest(getListEmailTemplatesUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getCreateEmailTemplateUrl = () => {
    return `/api/backoffice/email-templates`;
};
export const createEmailTemplate = async (emailTemplateRequestDto, options) => {
    return orvalRequest(getCreateEmailTemplateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(emailTemplateRequestDto)
    });
};
;
export const getRunCustodyCustomerSyncUrl = () => {
    return `/api/backoffice/custody/customer/sync`;
};
export const runCustodyCustomerSync = async (options) => {
    return orvalRequest(getRunCustodyCustomerSyncUrl(), {
        ...options,
        method: 'POST'
    });
};
;
export const getListAccessGrantsUrl = () => {
    return `/api/backoffice/access-grants`;
};
export const listAccessGrants = async (options) => {
    return orvalRequest(getListAccessGrantsUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getCreateAccessGrantUrl = () => {
    return `/api/backoffice/access-grants`;
};
export const createAccessGrant = async (accessGrantRequestDto, options) => {
    return orvalRequest(getCreateAccessGrantUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(accessGrantRequestDto)
    });
};
;
export const getGetPortalWalletUrl = () => {
    return `/api/portal/wallet`;
};
export const getPortalWallet = async (options) => {
    return orvalRequest(getGetPortalWalletUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetPortalPaymentUrl = (params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/portal/payment?${stringifiedParams}` : `/api/portal/payment`;
};
export const getPortalPayment = async (params, options) => {
    return orvalRequest(getGetPortalPaymentUrl(params), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetPortalPaymentProcessUrl = () => {
    return `/api/portal/payment/process`;
};
export const getPortalPaymentProcess = async (options) => {
    return orvalRequest(getGetPortalPaymentProcessUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getListPortalPaymentsUrl = () => {
    return `/api/portal/payment/all`;
};
export const listPortalPayments = async (options) => {
    return orvalRequest(getListPortalPaymentsUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetPortalDocumentUrl = (type) => {
    return `/api/portal/documents/${type}`;
};
export const getPortalDocument = async (type, options) => {
    return orvalRequest(getGetPortalDocumentUrl(type), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetPortalConfigUrl = () => {
    return `/api/portal/config`;
};
export const getPortalConfig = async (options) => {
    return orvalRequest(getGetPortalConfigUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getListBackofficePaymentsUrl = () => {
    return `/api/backoffice/payment`;
};
export const listBackofficePayments = async (options) => {
    return orvalRequest(getListBackofficePaymentsUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetBackofficeAuthenticatedUserUrl = () => {
    return `/api/backoffice/me`;
};
export const getBackofficeAuthenticatedUser = async (options) => {
    return orvalRequest(getGetBackofficeAuthenticatedUserUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getListProviderEmailTemplatesUrl = () => {
    return `/api/backoffice/email/provider/templates`;
};
export const listProviderEmailTemplates = async (options) => {
    return orvalRequest(getListProviderEmailTemplatesUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetBackofficeCustomerUrl = (id) => {
    return `/api/backoffice/customers/${id}`;
};
export const getBackofficeCustomer = async (id, options) => {
    return orvalRequest(getGetBackofficeCustomerUrl(id), {
        ...options,
        method: 'GET'
    });
};
;
export const getListBackofficeCustomerPaymentsUrl = (id) => {
    return `/api/backoffice/customers/${id}/payments`;
};
export const listBackofficeCustomerPayments = async (id, options) => {
    return orvalRequest(getListBackofficeCustomerPaymentsUrl(id), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetBackofficeCustomerKycReliancePersonUrl = (id) => {
    return `/api/backoffice/customers/${id}/kyc/reliance-person`;
};
export const getBackofficeCustomerKycReliancePerson = async (id, options) => {
    return orvalRequest(getGetBackofficeCustomerKycReliancePersonUrl(id), {
        ...options,
        method: 'GET'
    });
};
;
export const getGetBackofficeConfigUrl = () => {
    return `/api/backoffice/config`;
};
export const getBackofficeConfig = async (options) => {
    return orvalRequest(getGetBackofficeConfigUrl(), {
        ...options,
        method: 'GET'
    });
};
;
export const getListBackgroundTaskRunsUrl = () => {
    return `/api/backoffice/background-tasks/runs`;
};
export const listBackgroundTaskRuns = async (options) => {
    return orvalRequest(getListBackgroundTaskRunsUrl(), {
        ...options,
        method: 'GET'
    });
};
//# sourceMappingURL=token-api.js.map